import { IBillingCustomerInvoice, ICorrectPaymentDto, IPaymentCorrectionEvidence } from '../../compiler/billing.interface';
import { moneyCents } from './billingPaymentWorkflow';

export interface CorrectionEvidence {
  key: string;
  uuid?: string;
  file?: File;
  name: string;
  url: string;
  type: string;
  amount: string;
  transferDate: string;
  transferReference: string;
  note: string;
  removed?: boolean;
}
export const correctionEvidenceMetadata = (entry: CorrectionEvidence): IPaymentCorrectionEvidence => ({
  ...(entry.uuid ? { uuid: entry.uuid } : {}), transfer_amount: Number(entry.amount), transfer_date: entry.transferDate,
  transfer_reference: entry.transferReference.trim(), notes: entry.note,
});
export const validateCorrectionAllocation = (invoices: IBillingCustomerInvoice[], amounts: Record<string, string>, total: number) => {
  const errors: string[] = [];
  const allocations = invoices.map(row => ({ invoice_uuid: row.uuid, amount: Number(amounts[row.uuid] || 0) })).filter(row => row.amount !== 0);
  if (!invoices.length) errors.push('เลือกบิลอย่างน้อย 1 ใบ');
  if (invoices.some(row => row.has_pending_payment || row.pending_payment_uuid)) errors.push('มีบิลรอตรวจในรายการรับชำระอื่น กรุณานำออกหรือจัดการรายการเดิมก่อน');
  if (!Number.isFinite(total) || total <= 0 || Math.abs(total * 100 - moneyCents(total)) > 0.000001) errors.push('ยอดรับชำระต้องมากกว่า 0 และทศนิยมไม่เกิน 2 ตำแหน่ง');
  const outstanding = new Map(invoices.map(row => [row.uuid, Number(row.outstanding_amount)]));
  if (allocations.some(row => !Number.isFinite(row.amount) || row.amount <= 0 || Math.abs(row.amount * 100 - moneyCents(row.amount)) > 0.000001 || moneyCents(row.amount) > moneyCents(outstanding.get(row.invoice_uuid) || 0))) errors.push('ยอดตัดบิลต้องไม่ติดลบ ไม่เกินยอดค้าง และทศนิยมไม่เกิน 2 ตำแหน่ง');
  const allocated = allocations.reduce((sum, row) => sum + moneyCents(row.amount), 0) / 100;
  if (moneyCents(allocated) !== moneyCents(total)) errors.push('ยอดตัดบิลรวมต้องตรงกับยอดรับชำระ');
  return { errors, allocations, allocated, remaining: invoices.reduce((sum, row) => sum + moneyCents(Number(row.outstanding_amount)), 0) / 100 - allocated };
};
export interface CorrectionAttempt {
  uuid: string;
  dto: ICorrectPaymentDto;
  files: Array<{ name: string; size: number; type: string }>;
}
export const correctionFilesMatch = (expected: CorrectionAttempt['files'], files: File[]) => expected.length === files.length && expected.every((entry, index) => entry.name === files[index].name && entry.size === files[index].size && entry.type === files[index].type);
export const readCorrectionAttempt = (storage: Pick<Storage, 'getItem'>, key: string): CorrectionAttempt | null => {
  const raw = storage.getItem(key);
  if (!raw) return null;
  const value = JSON.parse(raw);
  if (!value?.uuid || !value?.dto?.client_request_id || !Array.isArray(value.files)) throw new Error('ข้อมูลกู้คืนไม่สมบูรณ์ กรุณาติดต่อผู้ดูแลก่อนทำรายการซ้ำ');
  return value;
};
